import json from "assets/json-files/choose-template.json";
import LogosAvatarSVG from "assets/svg/logos-avatar";
import PromotionAvatarSVG from "assets/svg/promotions-avatar";
import ProofPointsAvatarSVG from "assets/svg/proof-points-avatar";
import StatisticsAvatarSVG from "assets/svg/stastics-avatar";
import TestimonialAvatarSVG from "assets/svg/testimonial-avatar";
import VideosAvatarSVG from "assets/svg/videos-avatar";
import Button from "components/button/button";
import PopupComponent from "components/popup/popup";
import PopupContent from "components/popup/popup-content";
import _ from "lodash";
import { useRef } from "react";

const TYPES = [
  {
    type: "proof-points",
    icon: <ProofPointsAvatarSVG />,
  },
  {
    type: "testimonials",
    icon: <TestimonialAvatarSVG />,
  },
  {
    type: "videos",
    icon: <VideosAvatarSVG />,
  },
  {
    type: "promotions",
    icon: <PromotionAvatarSVG />,
  },
  {
    type: "statistics-data",
    icon: <StatisticsAvatarSVG />,
  },
  {
    type: "logos",
    icon: <LogosAvatarSVG />,
  },
];

export default function CampaignPopupTemplateType({
  className = "absolute p-2 box-shadow -left-14 top-4",
  actveColor = "bg-primary",
  type = "proof-points",
}) {
  const tutorialContent = json;
  const ref = useRef();
  const obj = _.find(TYPES, { type: type });
  // const modal = useDialogHook(TutorialVideoModal);

  const toggleTooltip = () => {
    ref.current.toggle();
  };

  // const showVideo = () => {
  //   modal({});
  //   toggleTooltip();
  // };

  return tutorialContent.map((content, index) => {
    return (
      // Should depend on its type
      content.type === type && (
        <PopupComponent
          contentClassName="builder-popout"
          key={index}
          activeColor={actveColor}
          position="left center"
          className={"animate-btn " + className}
          styles={content.styles}
          closeOnDocumentClick={true}
          ref={ref}
        >
          <PopupContent
            width="500px"
            footer={
              <span className="w-full">
                {/* <Button
                  buttonName="WATCH VIDEO TUTORIAL"
                  buttonTextClass="text-black text-xs font-bold flex px-3"
                  buttonClass="bg-transparent rounded-full py-2.5 border border-black mr-2"
                  buttonType="transparent"
                  buttonWidth="65%"
                  iconAlign="left"
                  icon={<FaPlay className="mr-0.5 mt-0.5" />}
                  onClick={showVideo}
                /> */}
                <Button
                  buttonName="GOT IT"
                  buttonTextClass="text-white text-xs font-bold"
                  buttonClass="bg-primary rounded-full py-2.5 float-right"
                  buttonWidth="30%"
                  onClick={toggleTooltip}
                />
              </span>
            }
          >
            {/* content */}
            <div
              className={
                content.type === "promotions"
                  ? "flex flex-row"
                  : "px-6 flex flex-row"
              }
            >
              <div>{obj?.icon}</div>
              <div className="pt-3 pl-4">
                <p className="leading-6 mb-2 font-semibold">{content.title}</p>
                <p className="text-sm">{content.description}</p>
                {content.list_items.length > 0 && (
                  <ul className="pl-5 pt-2 list-disc text-13">
                    {content.list_items.map((item, index) => {
                      return (
                        <li
                          key={index}
                          className={`${
                            content.list_items.length !== index + 1 && "pb-2"
                          }`}
                        >
                          {item}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            </div>
            {/* content */}
          </PopupContent>
        </PopupComponent>
      )
    );
  });
}
